<template>
    <div class="traveler-item">
        <span
            class="traveler-minus"
            v-if="index > 0"
            v-html="$icon('remove')"
            @click="$emit('removeItem', index)"
        ></span>
        <div class="traveler-input traveler-name">
            <app-label>
                {{ trans("trip_info.full_name") }}
            </app-label>
            <app-input
                v-model="traveler.name"
                :message="errors.get(`travelers.${index}.name`)"
            ></app-input>
        </div>

        <div class="traveler-input traveler-birth-date">
            <app-label>
                {{ trans("trip_info.birth_date") }}
            </app-label>

            <date-input
                v-model="traveler.birth_date"
                :message="errors.get(`travelers.${index}.birth_date`)"
                :typeable="true"
                icon="calendar_new"
                manual
            />

        </div>
        <div class="traveler-input traveler-id">
            <app-label>
                {{ trans("trip_info.id_number") }}
            </app-label>
            <app-input
                v-model="traveler.id"
                type="number"
                :message="errors.get(`travelers.${index}.id`)"
            ></app-input>
        </div>
        <div class="traveler-input traveler-mail">
            <app-label>
                {{ trans("trip_info.email") }}
            </app-label>
            <app-input
                v-model="traveler.mail"
                type="email"
                :message="errors.get(`travelers.${index}.mail`)"
            ></app-input>
        </div>

        <div class="traveler-input traveler-sex">
            <app-label>
                {{ trans("trip_info.gender") }}
            </app-label>
            <app-text-radio-buttons
                v-model="traveler.sex"
                :items="travelerGenders"
                :message="errors.get(`travelers.${index}.sex`)"
            >
            </app-text-radio-buttons>
            <p class="message"></p>
        </div>
    </div>
</template>
<script>

import DateInput from "../../Forms/DateInput.vue";

export default {
    components: {
        DateInput,
    },
    props: {
        traveler: [Object],
        constants: [Object],
        trans: [Function],
        errors: [Object],
        index: Number
    },
    data() {
        return {
            travelerGenders: [
                {
                    label: this.trans("trip_info.male"),
                    value: this.constants.SEX_MALE,
                    icon: "male",
                    icon_checked: "male_checked"
                },
                {
                    label: this.trans("trip_info.female"),
                    value: this.constants.SEX_FEMALE,
                    icon: "female",
                    icon_checked: "female_checked"
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.traveler-item {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 40px;
    row-gap: 20px;
    margin-bottom: 60px;
    position: relative;
    align-items: flex-end;

    @media (max-width: $mobile) {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .traveler-birth-date {
        ::v-deep {
            .masked-date-input {

                width: 100%;
                border-radius: 100px;
                border: 1px solid rgba(33, 67, 146, 0.2);
                background: $lightest-gray;
                height: 50px;
                margin: unset;
            }
        }
    }

    .traveler-input {
        width: 100%;

        .app-label-wrapper {
            margin-bottom: 10px;

            ::v-deep {
                label {
                    color: rgba(0, 0, 0, 0.6);
                    text-align: right;
                    font-size: 15px;
                    font-weight: bold;
                    display: block;
                    margin-bottom: 0;
                }
            }
        }

        &.traveler-sex {
            grid-column: span 2;
        }
    }

    .traveler-minus {
        position: absolute;
        top: 0;
        right: -30px;
        cursor: pointer;
    }
}
</style>
